(function () {
    'use strict';

    // @ngInject
    Services.ObjectPath = function ObjectPath($window) {
        return $window.objectPath;
    };


}());